import axios from "axios";

export const handleAxiosError = (error: unknown, defaultMessage: string): never => {
  if (axios.isAxiosError(error)) {
    if (error.response) {
      console.error(error);
      throw new Error(`Error ${error.response.status}: ${error.response.data.message}`);
    } else if (error.code === 'ERR_NETWORK') {
      console.error(error);
      throw new Error('Error de conexión. Verifica tu conexión a Internet.');
    } else {
      console.error(error);
      throw new Error(defaultMessage);
    }
  } else {
    console.error(error);
    throw new Error(defaultMessage);
  }
};